import KpiCard from '../common/KpiCard';
import useMetric from '../../hooks/useMetric';
import { formatNumber, formatPercent } from '../../utils/format';

export default function AiResponseMetricCard() {
  const { status, data, error, retry } = useMetric('aiResponse');
  const delta = data ? Math.round((data.value - data.previous) * 10) / 10 : null;
  return (
    <KpiCard
      testId="kpi-ai-response" title="AI Resolution Rate" icon="bi-robot" tone="success" to="/analytics"
      status={status} error={error} onRetry={retry} emptyText="No AI responses yet."
      value={data && formatPercent(data.value)} delta={delta}
      sparkline={data?.sparkline} footnote={data && `${formatNumber(data.messages)} AI messages`}
    />
  );
}
